import dynamic from 'next/dynamic';
import { TabListProps } from './TabList.types';
import { LoadingSkeleton as Skeleton } from '../../atoms';
import { LOADER_CONFIGS } from '../../constants/constants';

export const TabListMGP = dynamic<TabListProps>(() => import('./TabList').then(module => module.TabList), {
  loading: () => <Skeleton customSkeletonConfig={LOADER_CONFIGS.TabListLoadingConfig} isMarginTop={false} />,
});
